import { action, makeObservable, observable } from 'mobx';

class PinnedPanelStore {
	@observable openByScope = {};
	@observable countByScope = {};

	constructor() {
		makeObservable(this);
	}

	isOpen(scope) {
		return this.openByScope[scope] ?? false;
	}

	getCount(scope) {
		return this.countByScope[scope] ?? 0;
	}

	@action
	toggle(scope) {
		this.openByScope = { ...this.openByScope, [scope]: !this.isOpen(scope) };
	}

	@action
	close(scope) {
		this.openByScope = { ...this.openByScope, [scope]: false };
	}

	@action
	setCount(scope, count) {
		this.countByScope = { ...this.countByScope, [scope]: count };
	}
}

export const pinnedPanelStore = new PinnedPanelStore();
